import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import Header from "./Header/Header";
import SEOHead from "./SEO/SEOHead";

import "../css/MainPage.css";
import Footer from "./Footer/footer";
import Banner from "./Hero/banner";
import Store from "./Hero/Store";
import CardSection from "./Hero/CardSection";
import Testops from "./Hero/Testops";
import QATestingSection from "./Hero/QATestingSection";
import AnnouncementSection from "./Hero/AnnouncementSection";
import Rightforyou from "./WhyTestops/Rightforyou";

const MainPage = () => {
  const location = useLocation();
  const [getTestOps, setGetTestOps] = useState(false);

  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Froth TestOps",
    "url": "https://frothtestops.com",
    "logo": "https://frothtestops.com/og-image.png",
    "description": "Top Test Management Tools for Smarter QA & Projects",
    "foundingDate": "2023",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "support@frothtestops.com"
    },
    "sameAs": [
      "https://twitter.com/frothtestops",
      "https://linkedin.com/company/frothtestops"
    ]
  };

  return (
    <>
      <SEOHead
        title="Top Test Management Tools for Smarter QA & Projects"
        description="Discover top test management tools that simplify QA workflows, enhance teamwork, boost test coverage, and help deliver faster, high-quality projects."
        keywords="test management, QA tools, software testing, test automation, Froth TestOps"
        ogImage="/og-image.png"
        structuredData={structuredData}
      />

      <div
        className={`fd-main-wrapper ${
          location.pathname !== "/" ? "page-padding" : ""
        }`}
      >
        <Header />
        <Banner setGetTestOps={setGetTestOps} />
        <CardSection />
        <Testops />
        <QATestingSection />
        <AnnouncementSection />
        <Store />

        {getTestOps && (
          <Rightforyou
            getTestOps={getTestOps}
            setGetTestOps={setGetTestOps}
          />
        )}

        <Footer />
      </div>
    </>
  );
};

export default MainPage;